import * as Redux from 'redux';
import * as _ from 'lodash';
import { ActionType } from '../actions/index';
import { ISearchResultData } from '../objects/iSearchResultData';
import { ISearchFacet } from '../objects/iSearchFacet';

export class SearchState {
    isLoading: boolean;
    displayStart: number;
    displayLength: number;
    searchResultData: ISearchResultData;
    searchFacets: ISearchFacet[];
    showSearchBar: boolean;
    defaultCatalogNode: string;
    currentCountry: string;
}

export default function searchReduce(state: SearchState, action) {
    switch (action.type) {
        case ActionType.LOAD_STATE_FROM_STORAGE:
            return _.assign({}, state, {
                searchFacets: action.persistedState.searchFacets,
                displayStart: action.persistedState.displayStart,
                displayLength: action.persistedState.displayLength
            });
        case ActionType.REQUEST_RESULTS:
            return _.assign({}, state, { isLoading: true });
        case ActionType.RECEIVE_RESULTS:
            return _.assign({}, state, {
                isLoading: false,
                searchResultData: action.searchResultData
            });
        case ActionType.CHANGE_LENGTH:
            return _.assign({}, state, { displayLength: parseInt(action.newDisplayLength), displayStart: parseInt(action.newDisplayStart) });
        case ActionType.PREVIOUS_PAGE:
            return _.assign({}, state, { displayStart: state.displayStart - state.displayLength });
        case ActionType.NEXT_PAGE:
            return _.assign({}, state, { displayStart: state.displayStart + state.displayLength });
        case ActionType.JUMP_TO_PAGE:
            return _.assign({}, state, { displayStart: state.displayLength * (action.page) });
        case ActionType.UPDATE_KEYWORD:
            let facetsCreate = state.searchFacets;
            let keywordFacet = _.find(facetsCreate, (item) => item.facet == 'Keyword');
            if (keywordFacet == undefined || action.search[0].Value != keywordFacet.search[0].Value) {
                facetsCreate = [];
                facetsCreate.push({ facet: action.name, search: action.search });
            }
            return _.assign({}, state, { searchFacets: facetsCreate, displayStart: 0 });
        case ActionType.INIT_KEYWORD:
            let keywordFacetInit = state.searchFacets;
            let keywordFacetToInit = _.find(keywordFacetInit, (item) => item.facet == 'Keyword');
            if (keywordFacetToInit == undefined || action.search[0].Value != keywordFacetToInit.search[0].Value) {
                keywordFacetInit = [];
                keywordFacetInit.push({ facet: action.name, search: action.search });
            }
            return _.assign({}, state, { searchFacets: keywordFacetInit });
        case ActionType.UPDATE_FACET:
            let facetsUpdate = state.searchFacets;
            let facetToUpdate = _.find(facetsUpdate, (item) => item.facet == action.name);
            if (facetToUpdate == undefined) {
                facetToUpdate = { facet: action.name, search: action.search };
                facetsUpdate.push(facetToUpdate);
            }
            else {
                facetToUpdate.search = action.search;
            }
            return _.assign({}, state, { searchFacets: facetsUpdate, displayStart: 0 });
        case ActionType.INIT_FACET:
            let facetsInit = state.searchFacets;
            let facetToInit = _.find(facetsInit, (item) => item.facet == action.name);
            if (facetToInit == undefined) {
                facetToInit = { facet: action.name, search: action.search };
                facetsInit.push(facetToInit);
            }
            else {
                facetToInit.search = action.search;
            }
            return _.assign({}, state, { searchFacets: facetsInit });
        default:
            return state;
    }
}